import ContactUsManager from "../../services/contact/contactUsManager";
import CustomerDataValidator from "../../services/contact/bookingManagement/customerDataValidator";
import BookingCancelFormManager from "../../services/contact/bookingCancelFormManager";
import ContactWithoutBookingValidator from "../../services/forms/validator/contact/contactWithoutBookingValidator";
import ScrollToManager from "../../services/scrollToManager";
import BookingPinsEmailSenderService from "../../services/contact/bookingPinsEmailSenderService";
import * as Swiper from "swiper";

$(function ()
{
    myApp.contactUsManager = new ContactUsManager();
    myApp.customerDataValidator = new CustomerDataValidator();
    let selectedHelpOptionBookingContactOption = $('#booking-contact-options option:selected');
    let url = new URL(window.location.href);
    if (selectedHelpOptionBookingContactOption.length > 0 &&
        (url.href.includes('?gestion_reserva') || url.href.includes('&gestion_reserva'))
    ) {
        let selectBookingContact = selectedHelpOptionBookingContactOption.closest('select')[0];

        if (selectBookingContact) {
            $('[data-result=loading]').show();
            myApp.contactUsManager.selectHelpOption(selectBookingContact);
        }
    }
    myApp.bookingCancelFormManager = new BookingCancelFormManager();
    myApp.contactWithoutBookingValidator = new ContactWithoutBookingValidator();
    myApp.scrollToManager = new ScrollToManager();
    new BookingPinsEmailSenderService();

    document.querySelectorAll('hotel-room-card').forEach(e => e.initializeSwiper(Swiper));
});
